export enum KYCType {
  KYC = 'kyc',
  KYCRFI = 'kycRfi',
}

export type KYCTypeUnion = 'kyc' | 'kycRfi'
